import React from 'react';
import { useSelector } from 'react-redux';
import * as printPdfSelectors from '@makemydeal/dr-dash-store/selectors/printPdfSelectors';
import { Snackbar } from '@interstate/components/Snackbar';
import { SnackbarWrapper } from '../baseDealFooter/Footer.style.interstate';

export const PrintPdfLoadingModal = () => {
    const isLoading = useSelector(printPdfSelectors.isLoading);
    const isForSharing = useSelector(printPdfSelectors.isForSharing);
    const isPublishing = useSelector(printPdfSelectors.isPublishing);
    const showLoading = isLoading && !isForSharing;

    return (
        <SnackbarWrapper>
            <Snackbar
                data-testid="print-pdf-loading-message"
                position="bottom-center"
                show={showLoading}
                message={
                    isPublishing
                        ? "We're currently publishing your offer to Sales View"
                        : "We're currently printing your offer details"
                }
                autoHide={false}
            />
        </SnackbarWrapper>
    );
};
